module.exports = __webpack_public_path__ + "media/images/logo_text-e360f44f8ea59838b3287a4044acbbe9.png";